import type { SmartAssetDefinitionDetails } from "../types/smartAssetDefinitions";

const definitionRegistry = new Map<string, SmartAssetDefinitionDetails>();

export function registerSmartAssetDefinition(
  assetId: string,
  definition: SmartAssetDefinitionDetails,
): void {
  definitionRegistry.set(assetId, definition);
}

export function getSmartAssetDefinition(assetId: string): SmartAssetDefinitionDetails | undefined {
  return definitionRegistry.get(assetId);
}

export function hasSmartAssetDefinition(assetId: string): boolean {
  return definitionRegistry.has(assetId);
}

export function clearSmartAssetDefinitions(): void {
  definitionRegistry.clear();
}

export function getSmartAssetDefinitionIds(): string[] {
  return Array.from(definitionRegistry.keys());
}
